import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

import { emailsValidator, telefonnumreValidator } from "@dffedb/forms";
import { IInstallationsoplysninger } from "@e-forsyning/common/installation";

export class StamoplysningerFormBuilder {
    public static opretForm(installationsoplysninger: IInstallationsoplysninger): UntypedFormGroup {
        const form = new UntypedFormBuilder().group({
            ejendomnr: [installationsoplysninger.ejendomnr],
            telefonnr: [installationsoplysninger.telefonnr, [telefonnumreValidator()]],
            beboeremail: [installationsoplysninger.beboeremail, [emailsValidator()]],
            vejnavn: [installationsoplysninger.vejnavn],
            husnr: [installationsoplysninger.husnr],
            litra: [installationsoplysninger.litra],
            litra2: [installationsoplysninger.litra2],
            postnr: [installationsoplysninger.postnr],
            bynavn: [installationsoplysninger.bynavn],
            navn: [installationsoplysninger.navn],
            navn2: [installationsoplysninger.navn2]
        });

        form.controls["ejendomnr"].disable();
        form.controls["telefonnr"].disable();
        form.controls["beboeremail"].disable();
        return form;
    }
}
